import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import {
  Snapshot,
  SnapshotSpectralMask,
  CreateSnapshotSpectralMaskDto,
} from 'types';

export const createMask = ({
  data,
  snapshotId,
}: {
  data: CreateSnapshotSpectralMaskDto;
  snapshotId: number;
}): Promise<SnapshotSpectralMask> => {
  return axios.post(`/api/snapshots/${snapshotId}/spectral-masks`, data);
};

type UseCreateMaskOptions = {
  snapshotId: number;
  config?: MutationConfig<typeof createMask>;
};

export const useCreateMask = ({ config, snapshotId }: UseCreateMaskOptions) => {
  return useMutation({
    onMutate: async (newMask) => {
      await queryClient.cancelQueries(['snapshot', snapshotId]);

      const previousSnapshot = queryClient.getQueryData<Snapshot>([
        'snapshot',
        snapshotId,
      ]);

      queryClient.setQueryData(['snapshot', snapshotId], {
        ...previousSnapshot,
        masks: [...(previousSnapshot?.masks || []), newMask.data],
      });

      return previousSnapshot;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['snapshot', snapshotId]);
    },
    ...config,
    mutationFn: createMask,
  });
};
